import { useState } from "react";
import { Tabs } from "../../../../components/common/Tabs";
import { useTheme } from "../../../../components/hooks/useTheme";
import RentalTemplates from "./RentalTemplates";
import GeneralSettings from "./GeneralSettings";

const tabs = [
  {
    label: "Rental Agreement",
  },
  {
    label: "General Settings",
  },
]

export const RentalAgreement = () => {
  const { themeStyles } = useTheme();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const hanbleTabChange = (index: number) => {
    setActiveIndex(index);
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <h1 className={`m-1 ${themeStyles.main.textHeadingColor}`}>Rental Agreement Settings</h1>

        <div className="w-full mt-2">
          <Tabs tabs={tabs} onChange={(index) => hanbleTabChange(index)} activeIndex={activeIndex} />
        </div>

        <div>
          {activeIndex === 0 && <RentalTemplates />}
          {activeIndex === 1 && <GeneralSettings />}
        </div>
      </div>
    </div>

  )
}
